import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { CarouselButton, CarouselItem, CarouselProvider } from '~/shared/molecules/Carousel'
import { CarouselButtonsWrapper } from '~/shared/molecules/Carousel/CarouselShards'

import { photoStyles } from '../CardShards'

export const StyledCarouselProvider = styled(CarouselProvider)<{ fullHeight: boolean }>`
  ${({ fullHeight }) =>
    fullHeight
      ? photoStyles
      : css`
          height: 100%;
        `};
`

export const StyledCarouselItem = styled(CarouselItem)<{ fullHeight: boolean }>`
  ${({ fullHeight }) =>
    fullHeight
      ? photoStyles
      : css`
          height: 100%;
        `};
`

export const StyledCarouselButton = styled(CarouselButton)`
  width: 2rem;
  height: 2rem;
  z-index: 1;
  pointer-events: all;
  img {
    height: 0.75rem;
  }

  &:hover {
    opacity: 1;
  }
`

export const StyledCarouselButtonsWrapper = styled(CarouselButtonsWrapper)`
  padding: 0 0.625rem;
`
